<template>
  <div class="cadastrar-motivo">
    <SidebarLayout3 :breadcrumb="breadcrumb" :pageTitle="pageTitle">
      <template #sidebar>
        <!-- AÇÕES DA PÁGINA -->
        <SidebarBlock class="page-actions">
          <Heading class="page-actions--heading">
            Ações da página
          </Heading>

          <!-- CRIAR -->
          <Button
            class="page-actions--button"
            :disabled="disableSaveButton"
            tooltipMinWidth="230"
            @click="createUpdateReason"
          >
            {{ saveButtonLabel }}
          </Button>

          <!-- CANCELAR -->
          <Button
            :link="`/motivos-de-reservas-perdidas`"
            element="router-link"
            class="page-actions--button"
            layout="outline"
          >
            CANCELAR
          </Button>
        </SidebarBlock>
      </template>

      <!-- CONTEÚDO PRINCIPAL -->
      <template #content>
        <!-- EXIBIÇÃO -->
        <div>
          <Heading class="heading__margin" level="3">
            {{ reasonId ? 'EDIÇÃO DE MOTIVO' : 'CADASTRO DE MOTIVO' }}
          </Heading>

          <!-- FORM -->
          <b-row align-v="center">
            <!-- DESCRICAO -->
            <b-col cols="3">
              <FormInput
                v-model="fields.descricao"
                maxlength="150"
                label="Descrição do motivo"
                placeholder="Indisponibilidade de data"
              />
            </b-col>
            <!-- CHECKBOX ISACTIVE -->
            <b-col class="checkbox-margin" cols="3">
              <InputCheckbox
                v-model="fields.ativo"
                :checked="fields.ativo"
                :infoIcon="true"
                tooltipMinWidth="200"
                infoText="Ative ou desative esse motivo"
                label="Ativo"
              />
            </b-col>
          </b-row>
        </div>
      </template>
    </SidebarLayout3>
  </div>
</template>

<script>
import SidebarLayout3 from '@/layouts/SidebarLayout3'
import SidebarBlock from '@/components/_base/patterns/SidebarBlock'
import Heading from '@/components/_base/elements/Heading'
import Button from '@/components/_base/elements/Button'
import FormInput from '@/components/_base/elements/FormInput'
import InputCheckbox from '@/components/_base/elements/InputCheckbox'

export default {
  name: 'CreateReason',
  components: {
    SidebarLayout3,
    SidebarBlock,
    Heading,
    Button,
    FormInput,
    InputCheckbox
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Configurações'
        },
        {
          label: 'Motivos de reservas perdidas',
          url: '/motivos-de-reservas-perdidas',
          isSpa: true /** se deve ser um link para o site novo ou antigo */
        }
      ],
      pageTitle: 'Cadastrar novo motivo',
      saveButtonLabel: 'Salvar',
      fields: {
        descricao: '',
        ativo: false
      },
      reasonId: ''
    }
  },
  computed: {
    disableSaveButton() {
      return this.fields.descricao.length < 3
    }
  },
  async created() {
    /** Verifica se é uma edição pelo parâmetro da url */
    this.reasonId = this.$route.params.id

    /** Se receber o id, trata-se de uma edição */
    if (this.reasonId) {
      /** Títulos da página no caso de edição */
      this.pageTitle = 'Editar motivo de reserva perdida'

      this.breadcrumb[1] = {
        label: 'Edição de novo motivo',
        url: `/motivos-de-reservas-perdidas/editar/${this.reasonId}`,
        isSpa: true /** se deve ser um link para o site novo ou antigo */
      }

      this.$reasonsLostReservation.getReason(this.reasonId).then((response) => {
        this.fields = response.data
      })
    } else {
      this.breadcrumb[1] = {
        label: 'Cadastro de novo motivo',
        url: '/motivos-de-reservas-perdidas/novo',
        isSpa: true /** se deve ser um link para o site novo ou antigo */
      }
    }
  },
  methods: {
    createUpdateReason() {
      if (this.reasonId) {
        this.$reasonsLostReservation
          .updateReason(this.fields)
          .then((response) => {
            if (response.status === 200) {
              this.$bus.$emit('show-alert-chip', {
                message: 'Motivo de reserva perdida editada com sucesso'
              })
              setTimeout(() => {
                this.$router.push({
                  path: '/motivos-de-reservas-perdidas'
                })
              }, 1000)
            }
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: `${error.messages[0]}`
            })
          })
      } else {
        this.$reasonsLostReservation
          .createReason(this.fields)
          .then((response) => {
            if (response.status === 200) {
              this.$bus.$emit('show-alert-chip', {
                message: 'Motivo de reserva perdida cadastrada com sucesso'
              })
              setTimeout(() => {
                this.$router.push({
                  path: '/motivos-de-reservas-perdidas'
                })
              }, 1000)
            }
          })
          .catch((error) => {
            this.$bus.$emit('show-alert-chip', {
              message: `${error.messages[0]}`
            })
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .lb-breadcrumb--link:nth-child(2) {
  cursor: default;
}
.page-actions {
  &--heading {
    margin-bottom: 15px;
  }

  &--button {
    & + & {
      margin-top: 10px;
    }
  }
}

.heading {
  &__margin {
    margin-bottom: 20px;
  }

  &__margin-2 {
    margin-bottom: 35px;
  }

  &__advice {
    margin-top: 10px;
    color: $blue;
    font-size: font-size('size-small');
  }
}

.checkbox-margin {
  margin-left: 20px;
}
</style>
